import { Injectable } from '@angular/core';
import { Util } from '@libs/utilities/util';
import { WebHelperService } from '@libs/libraries/frontend';
import { TypeResolve } from '@libs/constants';

import { EnumResearchTourElement } from '../research-tour.interface';


@Injectable({
	providedIn: 'root'
})
export class ResearchTourStepController {

	constructor(
		private webHelperService: WebHelperService
	) {}


	/**------------------------------------------------------
	 * Tour Step 6 (TM Menu)
	 */
	stepTmMenuOnStepLoad(): Promise<void> {
		return new Promise(async (resolve: TypeResolve): Promise<void> => {

			//0 - if already advanced options is visible then hide
			const advanceOptions: HTMLElement = document.getElementById(EnumResearchTourElement.TmSearchAdvancedOptions);
			if (Util.Basic.isUndefined(advanceOptions) || !advanceOptions.classList.contains('show')) {
				resolve();
				return;
			}

			//1 - check the element whether it is present in the dom or not, if not then throw error
			const clickableElement: HTMLElement = await this.webHelperService.waitForElement(EnumResearchTourElement.TmSearchAdvancedOptionsBtn);
			if (!clickableElement) throw new Error(`ProductTourResearch => stepTmMenuOnStepLoad => FATAL ERROR: TmSearchAdvancedOptionsBtn is not present in the DOM: ${clickableElement}`);

			//2 - if exists, click the element
			this.webHelperService.clickElementById(EnumResearchTourElement.TmSearchAdvancedOptionsBtn);
			resolve();
		});
	}

	stepTmMenuAfterStep(): Promise<void> {
		return new Promise(async (resolve: TypeResolve): Promise<void> => {

			//0 - check the element in the DOM until the element exists
			const clickableElement: HTMLElement = await this.webHelperService.waitForElement(EnumResearchTourElement.TmSearchAdvancedOptionsBtn);
			if (!clickableElement) throw new Error(`ProductTourResearch => stepTmMenuAfterStep => FATAL ERROR: TmSearchAdvancedOptionsBtn is not present in the DOM: ${clickableElement}`);

			//1 - if exists, click the element
			this.webHelperService.clickElementById(EnumResearchTourElement.TmSearchAdvancedOptionsBtn);
			resolve();
		});
	}


	/**------------------------------------------------------
	 * Tour Step 7 (Tm Search Advanced Options)
	 */
	stepTmSearchAdvancedOptionsOnStepLoad(): Promise<void> {
		return new Promise(async (resolve: TypeResolve): Promise<void> => {

			//0 - check the element whether it is present in the dom or not, if not then throw error
			const clickableElement: HTMLElement = await this.webHelperService.waitForElement(EnumResearchTourElement.TmSearchAdvancedOptionsBtn);
			if (!clickableElement) throw new Error(`ProductTourResearch => stepTmSearchAdvancedOptionsOnStepLoad => FATAL ERROR: TmSearchAdvancedOptionsBtn is not present in the DOM: ${clickableElement}`);

			//1 - if exists, click the element
			this.webHelperService.clickElementById(EnumResearchTourElement.TmSearchAdvancedOptionsBtn);
			resolve();
		});
	}

	stepTmSearchAdvancedOptionsBeforeStep(): Promise<void> {
		return new Promise(async (resolve: TypeResolve): Promise<void> => {

			//0 - check the element whether it is present in the dom or not, if not then throw error
			const clickableElement: HTMLElement = await this.webHelperService.waitForElement(EnumResearchTourElement.TmSearchAdvancedOptionsBtn);
			if (!clickableElement) throw new Error(`ProductTourResearch => stepTmSearchAdvancedOptionsBeforeStep => FATAL ERROR: TmSearchAdvancedOptionsBtn is not present in the DOM: ${clickableElement}`);

			//1 - if exists, click the element
			this.webHelperService.clickElementById(EnumResearchTourElement.TmSearchAdvancedOptionsBtn);
			resolve();
		});
	}


	/**------------------------------------------------------
	 * Tour Step 8 (Tutorials Menu)
	 */
	stepTutorialsMenuBeforeStep(): Promise<void> {
		return new Promise(async (resolve: TypeResolve): Promise<void> => {

			//0 - check the element whether it is present in the dom or not, if not then throw error
			const clickableElement: HTMLElement = await this.webHelperService.waitForElement(EnumResearchTourElement.TmSearchAdvancedOptionsBtn);
			if (!clickableElement) throw new Error(`ProductTourResearch => stepTutorialsMenuBeforeStep => FATAL ERROR: TmSearchAdvancedOptionsBtn is not present in the DOM: ${clickableElement}`);

			//1 - if exists, click the element
			this.webHelperService.clickElementById(EnumResearchTourElement.TmSearchAdvancedOptionsBtn);
			resolve();
		});
	}
}
